import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Pill, statementFlags } from './repairsUI';

/**
 * A statement's flags as chips, for its row in the Statements list: orange
 * for what needs attention, grey for a version nobody recorded, green once a
 * re-read of it was applied. `phone` draws them in the phone's sizes and
 * colours. Nothing without flags.
 */
export default function StatementFlagChips({ flags, phone = false }) {
  const { t } = useTranslation('repairs');
  return statementFlags(flags).map(({ key, attention, good }) => (phone ? (
    <Box
      as="span"
      key={key}
      display="inline-flex"
      alignItems="center"
      h="22px"
      px="8px"
      borderRadius="full"
      bg={attention ? 'phone.alertBg' : 'phone.chipBg'}
      color={attention ? 'phone.alertText' : good ? 'phone.income' : 'phone.muted'}
      fontSize="13px"
      fontWeight="600"
      whiteSpace="nowrap"
      flexShrink={0}
    >
      {t(`flags.${key}`)}
    </Box>
  ) : (
    <Pill key={key} tone={attention ? 'orange' : good ? 'green' : 'muted'}>{t(`flags.${key}`)}</Pill>
  )));
}
